// extracted by mini-css-extract-plugin
export default {"title":"Banner_title__v-WDo","subTitle":"Banner_subTitle__V97XC","bannerBtn":"Banner_bannerBtn__rcw6c"};